module.exports = __webpack_public_path__ + "static/prime-ira-bg-e0e5b1e9395bd72fc7e15386cf64159e.jpg";